import React, { useCallback, useEffect, useLayoutEffect, useState } from 'react'
import "./styles.css";
import { SignInForm } from 'common/features/auth/AuthModels';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { clearOTPState, otpClearDefault, resetPasswordRequest, verifyMobile, verifyOTP } from 'common/features/auth/AuthActions';
import OtpInput from 'react-otp-input';
import CountdownTimer from "components/timer/index";
import { RootState } from 'common/rootReducer';




export interface AuthLoginInterface {
    handleOnPageSwitch:(key:string)=>void;
    handleOnOTPSuccess:(key:string)=>void;
    otpPayload:any;
    currentActivePage:string;
    currentActiveBackPage:string;
    otpType:string;
  }


const AuthVerifyOTP = (props:AuthLoginInterface) => {

    const history = useHistory();
    const dispatch = useDispatch();

    const {handleOnPageSwitch,handleOnOTPSuccess,otpPayload,currentActivePage,currentActiveBackPage,otpType} = props;
    const [otp, setOtp] = useState("");
    const [counter, setCounter] = useState(30);
    const resendOTPLimit = 3;
    const [timerIterationCount, setTimerIterationCount] = useState(0);
    const [verifyEnabled, setVerifyEnabled] = useState(false);
    const [isOTPResendRequest, setIsOTPResendRequest] = useState(false);

    const isResendValid = timerIterationCount < 3;

    
    const OtpVerificationSuccess = useSelector((state: RootState) => state.auth.otpVerifiedSuccess);
    const OtpVerificationLoading = useSelector((state: RootState) => state.auth.otpVerficationLoading);
    const otpVerficationMessage = useSelector((state: RootState) => state.auth.otpVerificationMessage);

    const [otpErrMsg,setOtpErrMsg]  = useState('')

    useEffect(() => {
      dispatch(otpClearDefault())
    }, [])
    

    useEffect(() => {
        var numbers = /^[0-9]+$/;
        if (!otp.match(numbers)) {
          setOtp("");
        }
    
        if (otp.length == 6) {
          setVerifyEnabled(true);
        } else if (otp.length < 6) {
          setVerifyEnabled(false);
        }
      }, [otp]);


    const {register,errors,handleSubmit,control,getValues,setValue,watch, formState,} = useForm<SignInForm>({defaultValues: {userId: "",password: "",},});

    useEffect(() => {
      if (!OtpVerificationLoading && OtpVerificationSuccess && formState.isSubmitted) {
        handleOnOTPSuccess(currentActiveBackPage);
      } else if (!OtpVerificationLoading && !OtpVerificationSuccess && formState.isSubmitted) {
        setOtp("");
      }
    }, [OtpVerificationLoading]);

    const getSubmitButtonText = useCallback(() => {
      if (OtpVerificationLoading) {
        return "Verifying OTP";
      }
      return "Verify";
    }, [OtpVerificationLoading]);


    const onSubmit = () => {
      const {...tempPayload} = otpPayload;
      tempPayload.otp = otp;
      dispatch(verifyOTP(tempPayload));
    };

      const resendOTP = () => {
        setIsOTPResendRequest(timerIterationCount>1)
        dispatch(clearOTPState());
        if (timerIterationCount < resendOTPLimit) {
          const tempPayload = otpPayload;
          otpType == "reset_password" && dispatch(resetPasswordRequest(tempPayload));
          otpType == "register_password" && dispatch(verifyMobile(tempPayload))
          setCounter(30);
        }
      };

      const otpContainerStyle = {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        height: "100%",
      };
      const otpInputStyle = {
        width: "67.5%",
        height: "80%",
        fontSize: "calc(var(--wWidth) * 0.053)",
        borderRadius: "8px",
        border: "1px solid #C1C1C1",
        marginLeft: "10.5%",
      };

  return (
    <React.Fragment>
        <div id="sign-in-screen">
            <form id="sign-in-form" onSubmit={handleSubmit(onSubmit)}>
           
            <div className="forgot-password-title-container-ad">
                    <span>
                    {`Please enter OTP you receive in the mobile number entered ${
                        props?.title === "OTP VERIFICATION" ? "" : ""
                    }`}{" "}
                    {isOTPResendRequest && `or email`}{" "}
                    </span>
                </div>

                <div id="otp-input-ad">
                    <OtpInput
                        onChange={(otp: string) => {setOtp(otp); }}
                        numInputs={6}
                        value={otp}
                        isInputNum={true}
                        shouldAutoFocus={true}
                        containerStyle={otpContainerStyle}
                        inputStyle={otpInputStyle}
                      />
                </div>

                <div id="otp-input-row2-ad">
                    <div>
                    {counter == 0 && isResendValid ? (
                        <React.Fragment>
                        <span>Didn’t receive code?</span>
                        &nbsp;
                        <span onClick={resendOTP}> Resend</span>
                        </React.Fragment>
                    ) : null}
                    </div>
                    <CountdownTimer
                        count={timerIterationCount}
                        setCount={setTimerIterationCount}
                        counter={counter}
                        setCounter={setCounter}
                        />
                </div>

                <div id="links-container-ad">
                    <button id={verifyEnabled ? "sign-in-button-ad" : "sign-in-button-ad-disable"}type="submit" style={{ width: 305 }} disabled={!verifyEnabled}>
                        {getSubmitButtonText()}
                    </button>
                </div>
                <p className="otp-err-msg-ad">{otpVerficationMessage}</p>
                <span className="sign-up-form-error-msg desktop-login-form-error-msg" style={{ width: "305px" }}></span>
                {!isResendValid && (
                  <p className="otp-err-msg-ad">
                    Too many failed attempts, Please try again!
                  </p>
                )} 
            </form>
        </div>
    </React.Fragment>
  )
}

export default AuthVerifyOTP;